import * as React from "react";
import call from "../../call";
import axios from "axios";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import ButtonGroup from "@mui/material/ButtonGroup";
import LoadingButton from "@mui/lab/LoadingButton";
import Alert from "@mui/material/Alert";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import PropTypes from "prop-types";

const MODAL_STYLE = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function ModalAlert(props) {
  return props.message && props.message.length > 0 ? (
    <Alert severity="error">{props.message}</Alert>
  ) : (
    ""
  );
}

ModalAlert.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

function ClientSelector(props) {
  const [selectedClient, setSelectedClient] = React.useState({});
  const handleClientChange = (event) => {
    const clientId = event.target.value;
    const selectedClient = props.clients.find(
      (client) => client.id == clientId,
    );
    setSelectedClient(selectedClient);
    props.onChange(selectedClient);
  };

  return (
    <FormControl sx={{ width: "100%" }}>
      <InputLabel id="client-select-label">Client</InputLabel>
      <Select
        labelId="client-select-label"
        id="client-select"
        label="Client"
        value={selectedClient?.id ? selectedClient.id : ""}
        onChange={handleClientChange}
        disabled={props.clients.length == 0}
      >
        {props.clients.map((client) => (
          <MenuItem key={client.id} value={client.id}>
            {client.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

ClientSelector.propTypes = {
  clients: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function AddClientModal(props) {
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const handleSubmit = (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);

    const form = new FormData(event.target);
    call(
      axios({
        method: props.editMode ? "put" : "post",
        url: "/api/g2/client",
        data: form,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json, text/plain",
        },
      }),
    )
      .then((response) => {
        props.onClose();
      })
      .catch((error) => {
        setError(
          error.response.data?.error
            ? error.response.data?.error
            : "An error occured on trying to perform the operation!",
        );
        setLoading(false);
      });
  };

  const [clients, setClients] = React.useState([]);
  React.useEffect(() => {
    if (props.editMode) {
      setLoading(true);
      call(
        axios({
          method: "get",
          url: "/api/g2/client",
        }),
      )
        .then((response) => {
          setClients(response.data);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          setError(error.response.data.error);
        });
    }

    return () => setClients([]);
  }, []);

  const [isDeleteButtonEnabled, setDeleteButtonEnabled] = React.useState(false);
  const [clientData, setClientData] = React.useState({});
  const handleClientChange = (client) => {
    setClientData(client);
    setDeleteButtonEnabled(true);
  };

  const handleDeleteClick = (event) => {
    setLoading(true);
    setDeleteButtonEnabled(false);
    const clientId = clientData?.id ? clientData.id : 0;
    if (clientId && globalThis.confirm("Are you sure want delete the client?")) {
      call(
        axios({
          method: "delete",
          url: "/api/g2/client/" + clientId,
        }),
      )
        .then((response) => {
          setLoading(false);
          props.onClose();
        })
        .catch((error) => {
          setError(error.response.data.error);
          setLoading(false);
        });
    }
  };

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={MODAL_STYLE} component="form" onSubmit={handleSubmit} noValidate>
        <Stack sx={{ width: "100%" }} spacing={2}>
          <ModalAlert message={error} />
          {props.editMode && (
            <React.Fragment>
              <ClientSelector clients={clients} onChange={handleClientChange} />
              <input
                type="hidden"
                value={clientData?.id ? clientData.id : 0}
                name="id"
              />
            </React.Fragment>
          )}
          {!props.editMode && (
            <FormControl sx={{ width: "100%" }}>
              <TextField
                margin="normal"
                required
                fullWidth
                label="Client Name"
                name="name"
                autoFocus
              />
            </FormControl>
          )}
          <FormControl sx={{ width: "100%" }}>
            <TextField
                margin="normal"
                fullWidth
                label="API Key"
                name="api_token"
            />
          </FormControl>
          <FormControl sx={{ width: "100%" }}>
            {props.editMode ? (
              <ButtonGroup variant="contained">
                <LoadingButton fullWidth type="submit" loading={loading}>
                  Save
                </LoadingButton>
                <LoadingButton
                  fullWidth
                  loading={loading}
                  onClick={handleDeleteClick}
                  color="error"
                  disabled={!isDeleteButtonEnabled}
                >
                  Delete
                </LoadingButton>
              </ButtonGroup>
            ) : (
              <LoadingButton
                type="submit"
                loading={loading}
                variant="contained"
              >
                Save
              </LoadingButton>
            )}
          </FormControl>
        </Stack>
      </Box>
    </Modal>
  );
}

AddClientModal.propTypes = {
  editMode: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
